<template>
  <div class="gated-feature p-6 max-w-xl mx-auto text-center">
    <i class="pi pi-lock text-4xl text-orange-500 mb-4" />
    <h2 class="text-xl font-semibold text-gray-800 mb-2">
      {{ $t('GatedFeature.title') }}
    </h2>
    <p class="text-gray-600 mb-6">
      {{ $t('GatedFeature.description') }}
    </p>
    <Button class="btn-primary-accent" :label="$t('GatedFeature.backToHome')" icon="pi pi-home" @click="goHome" unstyled/>
  </div>
</template>

<script>
import Button from 'primevue/button';

export default {
  name: 'GatedFeaturePlaceholder',
  components: {
    Button,
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
  },
};
</script>
